module.exports = __webpack_public_path__ + "media/src/images/icon__sad--4-d155e7073709c4aaaf0cec6cb193cd5a.png";